import React from "react"
import { Button, Icon } from "@chakra-ui/core"

const Share = () => {
  const twitterRoot = "http://twitter.com/intent/tweet"
  const encodedShareText = encodeURIComponent("SARS-CoV-2 confirmed infections in Switzerland by canton made by @zcreativelabs")
  const shareUrl = `${twitterRoot}?url=https://sars-cov-2-switzerland.netlify.com/&text=${encodedShareText}&original_referer=https://sars-cov-2-switzerland.netlify.com/`
  return (
    <Button as="a" href={shareUrl} flex="none" ml="1.25rem">
      {"Share"}
      <Icon name="twitter" ml="0.5rem"/>
    </Button>
  )
}

export default Share